import React from "react";
import "./Header.css";

const Header: React.FC = () => {
  return (
    <header className="header-container">
      <h1>Welcome to BrainFlex</h1>
    </header>
  );
};

export default Header;